import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { ready as uniframeReady, getByGlobalsComponent } from '@/hooks/uniframe';
import { safeToFormat, toFormat } from '@/utils/number';
import { get } from '@/utils/service';
import { error } from '@/utils/toast';

import './index.scss';

export const { hostname = '', protocol = '' } = window.location;

export const isBrowser = typeof window !== 'undefined';

const getLink = ({ code, locale, id }) => {
    if (!isBrowser) {
        return '';
    }

    const { origin, pathname } = window.location;
    const pathPrefix = pathname.split('/').slice(0, 4).join('/');
    const link = `${origin}${pathPrefix}/launchdetail/?id=${id}&ref=${code}`;
    return link;
};

export function useShare() {
    const store = useStore();
    const { t, locale } = useI18n();
    const isLogin = computed(() => store.state.user.userstate === 1);
    const userInfo = computed(() => store.state.user.info);
    const isLoading = ref(false);
    const inviteCode = ref('');

    const getInviteCode = async () => {
        if (!isLogin.value) return;

        const res = await get('@s1/code/info-msg', { client_id: userInfo.value?.id, scene: 2 });
        const { success, result, message: msg } = res;

        if (!success) {
            error(msg);
            isLoading.value = false;
            return;
        }
        // 注意：只有状态为0的邀请码才可用
        if (result.data.length && Number(result.data[0].status) === 0 && result.data[0].code) {
            inviteCode.value = result.data[0].code;
            // setCode(result.data[0].code)
        }
    };

    const getShareConfig = (detail) => {
        const link = getLink({
            code: inviteCode.value,
            locale,
            id: detail?.id,
        });

        const contentDesc = `<div class="share-tit">
            <div>${t('joinTokenSale', { token: detail?.token || '' })}</div>
            <div class="share-prize-pool">${t('totalSupply')}</div>
            <div class="share-prize-box">
                <span class="share-prize-price">${safeToFormat(
            detail?.prizepool,
        )}</span>
                <span class="share-prize-token">${detail?.token || ''}</span>
            </div>
            <div class="share-prize-tips">${t('commitTokenSale', { token: detail?.token || '' })}</div>
            </div>`;

        const content = `${t('clickToJoinSale', {
            token: detail?.token,
        })}${link}`;

        return {
            code: inviteCode.value,
            posterStyle: ['horizontal', 'vertical'],
            link,
            content,
            // contentLabel: t('lpn_share_text_label'),
            poster: [
                {
                    // 海报模板
                    template: 'default',
                    // 海报数据
                    templateData: {
                        backgroundImage: {
                            horizontal: '/spot-fe-launchpad/images/horizontal.png',
                            vertical: '/spot-fe-launchpad/images/vertical.png',
                        },
                        // 自定义内容文案
                        content: {
                            desc: contentDesc,
                        },
                        bottom: {
                            showCode: true,
                        },
                    },
                },
            ],
        };
    };

    const setVisible = async (detail) => {
        try {
            isLoading.value = true;
            await getInviteCode();

            if (inviteCode.value) {
                const ins = await getByGlobalsComponent('share');
                ins?.update({ visible: true, config: getShareConfig(detail) });
                isLoading.value = false;
            }
        } catch (err) {
            console.log(err);
        }
    };

    return {
        openShareModal: setVisible,
        shareModalInitLoading: isLoading,
    };
}
